import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SetupUserRepository from '@/repositories/setupUserRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSetupUserStore = defineStore({
    id: 'setupUser',
    state: () => ({}),
    getters: {},
    actions: {
        async setupUserDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const setupUserRepository = new SetupUserRepository();
            try {
                const response = await setupUserRepository.putUserDetailActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
});
